// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-qaq {
	background: #000000;
	box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
	height: 100vh;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 100;
	width: 240px;
	border-top-right-radius: 25px !important;
	border-bottom-right-radius: 25px !important;
}

.ant-layout-sider-children {
	display: flex;
	flex-direction: column;
}
.ant-menu {
	overflow: auto;
	background-color: #000000;
}

.ant-menu-item {
	border-radius: 0px !important;
	color: #b5b5b5;
	font-feature-settings:
		'liga' off,
		'clig' off;
	font-family: 'Henkel GT Flexa';
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	height: 40px;
	line-height: 40px;
}

.ant-menu-item-selected {
	background-color: rgba(255, 255, 255, 0.1) !important;
}

.css-dev-only-do-not-override-1v28nim .ant-menu-inline .ant-menu-root .ant-menu-item,
.css-dev-only-do-not-override-1v28nim .ant-menu-inline .ant-menu-root .ant-menu-submenu-title {
	color: #b5b5b5;
	width: 240px;
	border-radius: 0px !important;
	/* background-color: #000000 !important; */
	border-left: 2px solid #000;
}

.ant-menu-submenu-selected .ant-menu-submenu-title {
	color: #47e1e7 !important;
}

.ant-menu-item,
.ant-menu-item-active {
	color: #b5b5b5 !important;
}
/* .ant-menu-item-active {
	color: #47e1e7 !important;
} */

.ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-open .ant-menu-submenu-active .ant-menu-submenu-selected {
	border-radius: 0px !important;
}

.ant-layout-content {
	overflow-y: auto;
}

.sidebar-header {
	padding-left: 30px;
	height: 158px;
}

.sidebar-title {
	color: #ffffff;
	margin-top: 30px;
	width: 156px;
	height: 49.3px;
}

.sidebar-subtitle {
	color: #47e1e7;
	font-family: 'Segoe UI', sans-serif;
	font-size: 23px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	letter-spacing: 0.8px;
}

.sidebar-user {
	color: #fff;
	font-size: 12px;
	margin-top: 20px;
	text-align: left;
	display: flex;
	align-items: center;
	gap: 8px;
}

.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.sidebar-menu.css-dev-only-do-not-override-l9pxc0 {
	background-color: #000000 !important;
}

.ant-menu-item:hover {
	background-color: #b5b5b5b3 !important;
}

.ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-open.ant-menu-submenu-selected {
	color: #47e1e7 !important;
}

.css-dev-only-do-not-override-l9pxc0.ant-menu-light .ant-menu-submenu-selected > .ant-menu-submenu-title,
.css-dev-only-do-not-override-l9pxc0.ant-menu-light > .ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title {
	color: #47e1e7;
}
.ant-menu-submenu-selected .ant-menu-submenu-title {
	color: #47e1e7 !important;
}
.ant-menu-inline.ant-menu-root .ant-menu-submenu-title {
	color: #b5b5b5;
	font-size: 14px;
	height: 40px;
	line-height: 40px;
}

.ant-menu-submenu-title:hover {
	color: #b5b5b5;
}

.ant-menu-submenu-popup {
	box-shadow: 2px 0 6px rgba(0, 21, 41, 0.15);
	background: #222 !important;
	border: none;
}

.ant-menu-sub {
	background: #222;
	border: none;
}

.ant-menu-sub .ant-menu-item {
	padding-left: 32px;
	color: #b5b5b5;
	margin-left: revert-layer;
}

.ant-menu-item.ant-menu-item-only-child {
	padding-left: 39px !important;
	overflow: hidden;
}

.ant-menu-item-selected {
	color: #47e1e7 !important;
}

.ant-menu-sub .ant-menu-item-selected {
	color: #47e1e7 !important;
	border-left: 2px solid #47e1e7 !important;
}

.ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-selected {
	color: #47e1e7;
}

.ant-menu-sub .ant-menu-item:hover {
	background-color: #b5b5b5a2 !important;
}

.ant-menu-submenu-title .anticon {
	font-size: 24px !important;
}

.ant-menu-item-selected .anticon {
	color: #47e1e7;
}

.ant-menu-submenu-title-selected .anticon {
	color: #47e1e7;
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/index.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,2CAA2C;CAC3C,aAAa;CACb,eAAe;CACf,OAAO;CACP,MAAM;CACN,YAAY;CACZ,YAAY;CACZ,wCAAwC;CACxC,2CAA2C;AAC5C;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd;;YAEW;CACX,8BAA8B;CAC9B,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,qDAAqD;AACtD;;AAEA;;CAEC,cAAc;CACd,YAAY;CACZ,6BAA6B;CAC7B,0CAA0C;CAC1C,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;AACA;;GAEG;;AAEH;CACC,6BAA6B;AAC9B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,cAAc;CACd,mCAAmC;CACnC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,eAAe;CACf,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,2CAA2C;CAC3C,2BAA2B;CAC3B,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,yCAAyC;AAC1C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf","sourcesContent":[".sidebar-qaq {\n\tbackground: #000000;\n\tbox-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);\n\theight: 100vh;\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 100;\n\twidth: 240px;\n\tborder-top-right-radius: 25px !important;\n\tborder-bottom-right-radius: 25px !important;\n}\n\n.ant-layout-sider-children {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n.ant-menu {\n\toverflow: auto;\n\tbackground-color: #000000;\n}\n\n.ant-menu-item {\n\tborder-radius: 0px !important;\n\tcolor: #b5b5b5;\n\tfont-feature-settings:\n\t\t'liga' off,\n\t\t'clig' off;\n\tfont-family: 'Henkel GT Flexa';\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: normal;\n\theight: 40px;\n\tline-height: 40px;\n}\n\n.ant-menu-item-selected {\n\tbackground-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.css-dev-only-do-not-override-1v28nim .ant-menu-inline .ant-menu-root .ant-menu-item,\n.css-dev-only-do-not-override-1v28nim .ant-menu-inline .ant-menu-root .ant-menu-submenu-title {\n\tcolor: #b5b5b5;\n\twidth: 240px;\n\tborder-radius: 0px !important;\n\t/* background-color: #000000 !important; */\n\tborder-left: 2px solid #000;\n}\n\n.ant-menu-submenu-selected .ant-menu-submenu-title {\n\tcolor: #47e1e7 !important;\n}\n\n.ant-menu-item,\n.ant-menu-item-active {\n\tcolor: #b5b5b5 !important;\n}\n/* .ant-menu-item-active {\n\tcolor: #47e1e7 !important;\n} */\n\n.ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-open .ant-menu-submenu-active .ant-menu-submenu-selected {\n\tborder-radius: 0px !important;\n}\n\n.ant-layout-content {\n\toverflow-y: auto;\n}\n\n.sidebar-header {\n\tpadding-left: 30px;\n\theight: 158px;\n}\n\n.sidebar-title {\n\tcolor: #ffffff;\n\tmargin-top: 30px;\n\twidth: 156px;\n\theight: 49.3px;\n}\n\n.sidebar-subtitle {\n\tcolor: #47e1e7;\n\tfont-family: 'Segoe UI', sans-serif;\n\tfont-size: 23px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: normal;\n\tletter-spacing: 0.8px;\n}\n\n.sidebar-user {\n\tcolor: #fff;\n\tfont-size: 12px;\n\tmargin-top: 20px;\n\ttext-align: left;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n}\n\n.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.sidebar-menu.css-dev-only-do-not-override-l9pxc0 {\n\tbackground-color: #000000 !important;\n}\n\n.ant-menu-item:hover {\n\tbackground-color: #b5b5b5b3 !important;\n}\n\n.ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-open.ant-menu-submenu-selected {\n\tcolor: #47e1e7 !important;\n}\n\n.css-dev-only-do-not-override-l9pxc0.ant-menu-light .ant-menu-submenu-selected > .ant-menu-submenu-title,\n.css-dev-only-do-not-override-l9pxc0.ant-menu-light > .ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title {\n\tcolor: #47e1e7;\n}\n.ant-menu-submenu-selected .ant-menu-submenu-title {\n\tcolor: #47e1e7 !important;\n}\n.ant-menu-inline.ant-menu-root .ant-menu-submenu-title {\n\tcolor: #b5b5b5;\n\tfont-size: 14px;\n\theight: 40px;\n\tline-height: 40px;\n}\n\n.ant-menu-submenu-title:hover {\n\tcolor: #b5b5b5;\n}\n\n.ant-menu-submenu-popup {\n\tbox-shadow: 2px 0 6px rgba(0, 21, 41, 0.15);\n\tbackground: #222 !important;\n\tborder: none;\n}\n\n.ant-menu-sub {\n\tbackground: #222;\n\tborder: none;\n}\n\n.ant-menu-sub .ant-menu-item {\n\tpadding-left: 32px;\n\tcolor: #b5b5b5;\n\tmargin-left: revert-layer;\n}\n\n.ant-menu-item.ant-menu-item-only-child {\n\tpadding-left: 39px !important;\n\toverflow: hidden;\n}\n\n.ant-menu-item-selected {\n\tcolor: #47e1e7 !important;\n}\n\n.ant-menu-sub .ant-menu-item-selected {\n\tcolor: #47e1e7 !important;\n\tborder-left: 2px solid #47e1e7 !important;\n}\n\n.ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-selected {\n\tcolor: #47e1e7;\n}\n\n.ant-menu-sub .ant-menu-item:hover {\n\tbackground-color: #b5b5b5a2 !important;\n}\n\n.ant-menu-submenu-title .anticon {\n\tfont-size: 24px !important;\n}\n\n.ant-menu-item-selected .anticon {\n\tcolor: #47e1e7;\n}\n\n.ant-menu-submenu-title-selected .anticon {\n\tcolor: #47e1e7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
